import { filter } from 'lodash';
import { Service, ServicesMap } from 'app/service/types';
import { ID } from 'app/common/types';
import isHidden from './isServiceHidden';

export default function getVisibleServices(
  services: ServicesMap | Array<Service>,
  nodeSelectedApi?: ID
): Array<Service> {
  return filter(
    services,
    (service: Service) => !isHidden(service) || service.key === nodeSelectedApi
  );
}
